import React from 'react';
import { format } from 'date-fns';
import { Dialog } from '@mui/material';
import './styles/MeetingCancelConfirmDialog.css';

const MeetingCancelConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  meetingTitle,
  currentStartDate,
  reason,
  onReasonChange,
  reasonError = '',
  submitting = false,
}) => (
  <Dialog
    open={open}
    onClose={submitting ? undefined : onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ className: 'meeting-cancel-dialog__paper' }}
  >
    <div className="meeting-cancel-dialog meeting-form">
      <div className="meeting-cancel-dialog__body">
        <div className="meeting-cancel-dialog__header">
          <h2 className="meeting-cancel-dialog__title">Cancel this meeting?</h2>
          <button
            type="button"
            className="meeting-cancel-dialog__close"
            onClick={onClose}
            disabled={submitting}
            aria-label="Close cancel dialog"
          >
            ×
          </button>
        </div>

        <p className="meeting-cancel-dialog__subtitle">
          This will remove the meeting from the active list and move it to archives.
        </p>

        <div className="meeting-cancel-dialog__summary">
          <div className="meeting-cancel-dialog__summary-card">
            <span className="meeting-cancel-dialog__label">Meeting</span>
            <p className="meeting-cancel-dialog__value">{meetingTitle || 'Meeting'}</p>
          </div>
          <div className="meeting-cancel-dialog__summary-card">
            <span className="meeting-cancel-dialog__label">Scheduled time</span>
            <p className="meeting-cancel-dialog__value">
              {currentStartDate ? format(currentStartDate, 'MMM d, yyyy, h:mm a') : 'N/A'}
            </p>
          </div>
        </div>

        <div className="meeting-cancel-dialog__reason">
          <label className="meeting-cancel-dialog__label" htmlFor="meeting-cancel-reason">
            Cancel reason
          </label>
          <textarea
            id="meeting-cancel-reason"
            className={`meeting-form__textarea meeting-cancel-dialog__textarea${reasonError ? ' meeting-cancel-dialog__textarea--error' : ''}`}
            value={reason}
            onChange={onReasonChange}
            disabled={submitting}
            rows={4}
            placeholder="Add the reason for cancelling this meeting."
          />
          {reasonError && <p className="meeting-cancel-dialog__error">{reasonError}</p>}
        </div>
      </div>

      <div className="meeting-cancel-dialog__actions">
        <button
          type="button"
          className="meeting-cancel-dialog__button meeting-cancel-dialog__button--secondary"
          onClick={onClose}
          disabled={submitting}
        >
          Back
        </button>
        <button
          type="button"
          className="meeting-cancel-dialog__button meeting-cancel-dialog__button--danger"
          onClick={onConfirm}
          disabled={submitting}
        >
          {submitting ? 'Cancelling...' : 'Confirm cancellation'}
        </button>
      </div>
    </div>
  </Dialog>
);

export default MeetingCancelConfirmDialog;
